import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type KnowledgeBaseIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const KnowledgeBaseIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: KnowledgeBaseIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Knowledge Base'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <path
        d='M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
